<template>
  <div v-if="loanData">
    <section class="accent-text-box mb-2">
      <p>잔여 원금</p>
      <h3 class="amount font-size--24">{{ commaFormat(loanData.leftAmount) }}원</h3>
    </section>

    <div class="mb-2 linear-box rounded-3">
      <v-progress-linear
        :value="(loanData.repaidAmount / loanData.amount) * 100"
        height="24"
        class="rounded-3"
        color="primary"
        background-color="transparent"
      ></v-progress-linear>
    </div>

    <v-layout justify-space-between align-center class="mb-1 font-weight-black">
      <span>실행 금액</span>
      <span>{{ commaFormat(loanData.amount) }}원</span>
    </v-layout>
    <v-layout justify-space-between align-center class="mb-1 font-weight-black">
      <span>상환 금액</span>
      <span>{{ commaFormat(loanData.repaidAmount) }}원</span>
    </v-layout>
  </div>
</template>

<script>
import loanPropsMixin from '@/components/loan/loanPropsMixin'
import { commaFormat } from '@/filter/number'

export default {
  mixins: [loanPropsMixin],
  components: {},
  methods: { commaFormat },
}
</script>

<style lang="scss" scoped>
.text-box {
  p,
  h3 {
    line-height: 1.2;
  }
}

.linear-box {
  position: relative;
  height: 24px;
  background-color: #eee;
  .v-progress-linear {
    position: absolute;
  }
}
</style>
